module.exports = __webpack_public_path__ + "img/hp-v4.f3ea2ef0.svg";